import { render, staticRenderFns } from "./DtAvatar.vue?vue&type=template&id=09e070ce&"
import script from "./DtAvatar.vue?vue&type=script&lang=js&"
export * from "./DtAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports